class FillManager {
	constructor(ogForm, formData = 'data-form-fill', fieldData = 'data-field-fill', fillData = "data-fill") {
		this._init(ogForm, formData, fieldData, fillData)
	}
	_init(ogForm, formData, fieldData, fillData) {
		this.form = ogForm
		if(!this.form) {
			return
		}
		this.id = this.form.id
		this.el = document.querySelector('[' + formData + '="' + this.id + '"]')
		if(!this.el) {
			return
		}
		this.elFields = this.el.querySelectorAll('[' + fieldData +']')
		this.elFields.forEach(el => {
			const data = el.getAttribute(fieldData)
			const dataSplit = data.split(' ')
			el.type = dataSplit[0]
			el.id = dataSplit[1]
			el.fill = el.querySelectorAll('[' + fillData +']')
	})
		this.fillFields()
	}
	fillFields() {
		this.getOriginalFields().forEach((field, i) => {
			if(this.elFields[i] && this.elFields[i].fill) {
				this.setField(i, field)
			}
		})
	}
	getOriginalFields() {
		return this.form.fields
	}
	setField(index, field) {
		const elF = this.elFields[index]
		if(index < this.elFields.length && elF.id === field.id) {
			const value = field.getValue()
			if(elF.type === "field") {
				elF.fill[0].innerHTML = value
			} else if(elF.type === "radio") {
				for(let i = 0; i < elF.fill.length; i++) {
					if(i!=value) {
						elF.fill[i].style.display = "none"
					} else {
						elF.fill[i].style.display = ""
					}
				}
			}
		}
	}
	isActive() {
		let active = false
		if(this.el) {
			active = true
		}
		return active
	}
}

export default FillManager